module.exports = __webpack_public_path__ + "img/fly.970c24f4.png";